module.exports = __webpack_public_path__ + "static/media/DC-Motor-Controller1.d7a03549.png";